/** The report's four views, in tab order. The id is what `?view=` carries. */
export const REPORT_TABS = [
  { id: "checklist", label: "Checklist" },
  { id: "summary", label: "Summary" },
  { id: "list", label: "List view" },
  { id: "document", label: "Document view" },
] as const

export type ReportTabId = (typeof REPORT_TABS)[number]["id"]

export function isReportTabId(value: string | null): value is ReportTabId {
  return REPORT_TABS.some((t) => t.id === value)
}
